export const EnglishUsLang = {
  id: 'english_us',
  tokens: {
    /**
     * IMPORTANT: All the tokens must belong to a group mentioned in a comment like this one
     * IMPORTANT: The group must be mentioned with space separator ("Example group") or in camelCase format ("exampleGroup")
     */

    /**
     * Example group
     */
    // 'LNG_EXAMPLE_TOKEN': 'Example value'
    // !!!!!IMPORTANT: SOME MIGHT ALREADY EXISTS AND NEED TO BE UPDATED



    /**
     * REMOVE the tokens from below
     */
    // LNG_LAYOUT_ACTIVE_OUTBREAK_LABEL
    // LNG_SIDE_COLUMNS_ERROR_NO_COLUMN_SELECTED
    // LNG_SEARCH_LOCATIONS_AUTO_COMPLETE_LOADING_TEXT
    // LNG_SEARCH_LOCATIONS_AUTO_COMPLETE_HOVER_TOOLTIP
    // LNG_LIST_PAGES_BUTTON_BULK_ACTIONS_TOOLTIP
    // LNG_SIDE_FILTERS_COMPARATOR_LABEL_QUESTION_WHICH_ANSWER_DATE_FROM
    // LNG_SIDE_FILTERS_COMPARATOR_LABEL_QUESTION_WHICH_ANSWER_DATE_TO
    // LNG_SAVED_FILTERS_FIELD_LABEL_NAME_DESCRIPTION
    // ageButtonLabel="LNG_CASE_FIELD_LABEL_AGE_BUTTON"
    // dobButtonLabel="LNG_CASE_FIELD_LABEL_DATE_OF_BIRTH_BUTTON"
    // dobPlaceholder="LNG_CASE_FIELD_LABEL_DOB"
    // LNG_DIALOG_CONFIRM_CHANGE_CASE_EPI_CLASSIFICATION
    // LNG_PAGE_TERMS_OF_USE_TITLE
    // LNG_PAGE_TERMS_OF_USE_HEADER_TITLE
    // LNG_PAGE_VERSION_TEXT_DESCRIPTION
    // LNG_PAGE_VERSION_TITLE
    // LNG_LAYOUT_MENU_ITEM_VERSION_LABEL
    // LNG_PAGE_SET_SECURITY_QUESTIONS_DESCRIPTION_ALREADY_SET
    // LNG_PAGE_SYSTEM_BACKUPS_AUTOMATIC_BACKUP_SETTINGS_DIALOG_EXISTING_CONFIGURATION_INFO_DISABLE
    // LNG_PAGE_DASHBOARD_EPI_CURVE_TITLE
    // LNG_PAGE_DASHBOARD_EPI_CURVE_TITLE_DESCRIPTION
    // LNG_FOLLOW_UP_FIELD_LABEL_FILL_LOCATION_NO_LOCATION
    // LNG_PAGE_LIST_USAGE_LOCATIONS_LABEL_MORE_RECORDS
    // LNG_PAGE_GRAPH_CHAINS_OF_TRANSMISSION_BUTTON_APPLY_SETTINGS
    // LNG_PAGE_GRAPH_CHAINS_OF_TRANSMISSION_SHOW_LEGEND_LABEL
    // LNG_PAGE_GRAPH_SNAPSHOT_FILTER_FIRST_NAME_LABEL
    // LNG_PAGE_GRAPH_SNAPSHOT_FILTER_LAST_NAME_LABEL
    // LNG_PAGE_LIST_USAGE_LOCATIONS_NOT_SELECTED_OUTBREAK
    // LNG_PAGE_DASHBOARD_EPI_CURVE_REPORT_LABEL
    // LNG_COMMON_LABEL_ACTIONS
    // LNG_PAGE_BULK_ADD_CONTACTS_LABEL_ERROR_MSG
    // LNG_PAGE_BULK_ADD_CONTACTS_WARNING_INVALID_FIELDS
    // LNG_PAGE_BULK_ADD_CONTACTS_WARNING_NO_DATA
    // LNG_SHEET_CONTEXT_MENU_ROW_BELOW
    // LNG_SHEET_CONTEXT_MENU_ROW_ABOVE
    // LNG_SHEET_CONTEXT_MENU_CUT
    // LNG_PAGE_BULK_ADD_CONTACTS_WARNING_CASE_OR_EVENT_REQUIRED
    // LNG_PAGE_BULK_ADD_CONTACTS_VISUAL_ID_INFO_LABEL
    // LNG_PAGE_BULK_ADD_CONTACTS_LABEL_ERRORS
    // LNG_PAGE_BULK_ADD_CONTACTS_OF_CONTACTS_VISUAL_ID_INFO_LABEL
    // LNG_PAGE_BULK_ADD_CONTACTS_OF_CONTACTS_LABEL_ERRORS
    // LNG_PAGE_BULK_MODIFY_CONTACTS_OF_CONTACTS_LABEL_ERRORS
    // LNG_CASE_FIELD_LABEL_DUPLICATE_CONTACTS
    // LNG_CONTACT_FIELD_LABEL_DUPLICATE_CASES
    // LNG_PROGRESS_OPTION_LABEL_IN_PROGRESS
    // LNG_PROGRESS_OPTION_LABEL_COMPLETED
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_HEADING
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_SUBJECT
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH1
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH2
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH3
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH4
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH5
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH6
    // LNG_REFERENCE_DATA_CATEGORY_PASSWORD_RESET_PARAGRAPH7
    // LNG_REFERENCE_DATA_CATEGORY_TWO_FACTOR_AUTHENTICATION_HEADING
    // LNG_REFERENCE_DATA_CATEGORY_TWO_FACTOR_AUTHENTICATION_SUBJECT
    // LNG_REFERENCE_DATA_CATEGORY_TWO_FACTOR_AUTHENTICATION_PARAGRAPH1
    // LNG_REFERENCE_DATA_CATEGORY_TWO_FACTOR_AUTHENTICATION_PARAGRAPH2
    // LNG_PAGE_IMPORT_DATA_RETRIEVING_LOCATIONS
    // LNG_OUTBREAK_FIELD_LABEL_IS_CASE_DATE_OF_ONSET_REQUIRED
    // LNG_OUTBREAK_FIELD_LABEL_IS_CASE_DATE_OF_ONSET_REQUIRED_DESCRIPTION
    // LNG_OUTBREAK_TEMPLATE_FIELD_LABEL_IS_CASE_DATE_OF_ONSET_REQUIRED
    // LNG_OUTBREAK_TEMPLATE_FIELD_LABEL_IS_CASE_DATE_OF_ONSET_REQUIRED_DESCRIPTION
    // LNG_PAGE_GRAPH_CHAINS_OF_TRANSMISSION_CHAINS_FILTERED_BY_SIZE
    // LNG_PAGE_LIST_SYSTEM_CLIENT_APPLICATIONS_ACTION_ENABLE
    // LNG_PAGE_LIST_SYSTEM_CLIENT_APPLICATIONS_ACTION_DISABLE
    // LNG_PAGE_LIST_FOLLOW_UPS_REGISTERED_AS_CONTACT_TITLE
    // LNG_PAGE_LIST_FOLLOW_UPS_CONTACT_TITLE
    // LNG_PAGE_LIST_FOLLOW_UPS_GENERATE_BUTTON
    // LNG_PAGE_LIST_FOLLOW_UPS_ACTION_GENERATE_FOLLOW_UPS_DIALOG_TITLE
    // LNG_PAGE_LIST_RANGE_FOLLOW_UPS_EXPORT_BUTTON
    // LNG_PAGE_LIST_RANGE_FOLLOW_UPS_EXPORT_TITLE
  }
};
